import { render } from "./VerifyPG.vue?vue&type=template&id=5f19d626"
import script from "./VerifyPG.vue?vue&type=script&lang=js"
export * from "./VerifyPG.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__